import gloveMaintain from "../../../assets/Services_img/glovebox_maintain.jpg";

export const gloveboxInspectionPM = {
  hero: {
    title: "Glovebox Inspection & Preventive ",
    description:
      "Proactive maintenance services designed to ensure system integrity, operational safety, and long-term glovebox performance.",
      title2:"Maintenance",
      imgUrl:gloveMaintain
  },

  productsDetails: {
    imgList: [
      gloveMaintain
    ],

    productName: "Glovebox Inspection & Preventive Maintenance Service",

    description:
      "Our Glovebox Inspection & Preventive Maintenance service focuses on identifying potential failures before they impact operations. Certified engineers perform comprehensive system checks to maintain airtight integrity, stable atmosphere control, and safe working conditions across laboratory and industrial glovebox systems.",

    keyFeatures: [
      "Comprehensive inspection of gloves, ports, and securing rings",
      "Leak detection and pressure integrity verification",
      "Inspection of viewing panels and structural components",
      "Feedthrough, valve, and pressure control system checks",
      "Preventive maintenance recommendations and reporting",
    ],

    download: {
      title: "Download Service Overview PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Service Description",

    briefDescirption:
      "Regular inspection and preventive maintenance are essential to avoid unexpected downtime and contamination risks. This service ensures your glovebox operates within specified parameters, extends equipment lifespan, and supports compliance with laboratory safety and quality standards.",
  },
};
